export default __webpack_public_path__ + "static/media/9_16-story-ad-mobile.0ab3b3ac.png";